
import React, { useEffect } from 'react'
import './App.css';
import { useTranslation } from 'react-i18next';
import Banner from './components/bannerPage/banner';
import ComingSoon from './components/soonPage/soon';
import MobileComingSoon from './components/soonPage/mobileSoon';

const App = () => {

  const { t, i18n } = useTranslation();

  useEffect(() => {
    const changeLanguage = () => {
      i18n.changeLanguage("rs")
    }

    return changeLanguage()

  }, [1])


  let currentUrl = window.location.origin

  return (
    <div className="App">
      {currentUrl === "https://izaberitim.com" && <Banner />}

      {(currentUrl === "https://rs.izaberitim.com" || currentUrl === "https://ba.izaberitim.com") &&
        <>
          <ComingSoon />
          <MobileComingSoon />
        </>}


    </div>
  );
}

export default App;
